import React from "react";
import { OverlayTrigger, Stack } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import {
  DetailsList,
  DetailsListHeader,
} from "../../../../shared/styles/Card.styles";
import ContactListStyles from "./ContactList.styles";
import { IContactListProps } from "./ContactList.types";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import CardUtils from "../../Card.utils";
import { ContactInfoVM } from "../../../../api/generated/models";
import TOOL_TIP from "../../../tooltip/ToolTip.component";
import { ContactsLabel } from "../../../../shared/enums/labels.enums";

const CONTACT_LIST: React.FC<IContactListProps> = (
  props: IContactListProps
) => {
  const sendDataToGTM = useGTMDispatch();
  const { contacts, project } = props;
  const { name, email } = contacts.coordinator as ContactInfoVM;

  return (
    <DetailsList className="details-list">
      <DetailsListHeader
        className="details-list-header"
        direction="horizontal"
        data-testid="contact-details-list-header"
      >
        <h4>Project Contacts</h4>
      </DetailsListHeader>
      <Stack>
        <ContactListStyles.ContactsListItem
          className="contact-list-item"
          direction={
            /* istanbul ignore next */ isMobile ? "vertical" : "horizontal"
          }
          gap={/* istanbul ignore next */ isMobile ? 0 : 2}
        >
          <div className="label-cell">
            <OverlayTrigger
              trigger="click"
              rootClose
              transition
              placement={
                /* istanbul ignore next */ isMobile ? "bottom" : "right"
              }
              onToggle={
                /* istanbul ignore next */ (nextShow: boolean) => {
                  if (nextShow) {
                    sendDataToGTM({
                      event: "eventTracking",
                      category: "Construction",
                      action: `Tooltip Opened - ${ContactsLabel.COORDINATOR}`,
                      label: "Project Details - Contact List",
                    });
                  }
                }
              }
              overlay={
                /* istanbul ignore next */ TOOL_TIP({
                  contactsLabel: ContactsLabel.COORDINATOR,
                })
              }
            >
              <span>Coordinator</span>
            </OverlayTrigger>
          </div>
          <div>
            {CardUtils.renderEmailLink(
              name,
              email,
              project?.projectId,
              project?.projectTitle,
              sendDataToGTM
            )}
          </div>
        </ContactListStyles.ContactsListItem>
        <ContactListStyles.ContactsListItem
          className="contact-list-item"
          direction={
            /* istanbul ignore next */ isMobile ? "vertical" : "horizontal"
          }
          gap={/* istanbul ignore next */ isMobile ? 0 : 2}
        >
          <div className="label-cell">
            <OverlayTrigger
              trigger="click"
              rootClose
              transition
              placement={
                /* istanbul ignore next */ isMobile ? "bottom" : "right"
              }
              onToggle={
                /* istanbul ignore next */ (nextShow: boolean) => {
                  if (nextShow) {
                    sendDataToGTM({
                      event: "eventTracking",
                      category: "Construction",
                      action: `Tooltip Opened - ${ContactsLabel.MAIN_CONTACT}`,
                      label: "Project Details - Contact List",
                    });
                  }
                }
              }
              overlay={
                /* istanbul ignore next */ TOOL_TIP({
                  contactsLabel: ContactsLabel.MAIN_CONTACT,
                })
              }
            >
              <span>Main Contact</span>
            </OverlayTrigger>
          </div>
          <div>{contacts.mainContact}</div>
        </ContactListStyles.ContactsListItem>
      </Stack>
    </DetailsList>
  );
};
export default CONTACT_LIST;
